import { flowRange } from "../data/flowRange";
import { materialTables } from "../data/materialTables";
var Calculator = /** @class */ (function () {
    function Calculator(_a) {
        var userInput = _a.userInput, costSettings = _a.costSettings;
        this.variables = {};
        this.costs = {};
        this.total = { upper: 0, average: 0 };
        this.userInput = userInput;
        this.materialCosts = costSettings.wcc_material_costs;
        this.wellCosts = costSettings.wcc_well_costs;
    }
    Calculator.prototype.computeVariables = function () {
        var _this = this;
        var casingScreenDiameter = flowRange.find(function (range) {
            var value = _this.userInput.average_production;
            return value >= range.lower && value <= range.upper;
        }).casingScreenDiameter;
        /** Step 9 */
        this.variables.casing_diameter = casingScreenDiameter; // 9
        this.variables.screen_diameter = casingScreenDiameter; // 10
        var totalDepth = this.userInput.total_depth;
        var totalCasingLength = 0.6 * totalDepth;
        this.variables.total_casing_length = totalCasingLength; // 11
        this.variables.total_screen_length = totalDepth - totalCasingLength; // 12
        this.variables.sounding_tube_length = totalDepth * 0.5; // 13
        var annularSealDepth = this.userInput.annular_seal_depth;
        this.variables.annular_seal_depth = annularSealDepth; // 14
        this.variables.gravel_feed_tube_length = 2 * (annularSealDepth + 10); // 15
        var casingMaterialType = this.userInput.casing_screen_material_type;
        this.variables.screen_weight = materialTables[casingMaterialType][this.variables.casing_diameter].wellScreenWeight; // 16
        this.variables.casing_weight = materialTables[casingMaterialType][this.variables.casing_diameter].wellCasingWeight; // 17
        // costSettings;
        this.variables.casing_screen_material_cost = +this.materialCosts[casingMaterialType].well_casing_screen; // 18
        this.variables.sounding_tube_unit_cost = +this.materialCosts[casingMaterialType].sounding_tube; // 19
        this.variables.gravel_feed_tube_unit_cost = +this.materialCosts[casingMaterialType].gravel_tube; // 20
        var waterQuality = this.userInput.water_quality;
        var reliableEstimate = this.userInput.reliable_estimate;
        this.variables.water_quality_zone_tests = [waterQuality, reliableEstimate].includes("yes") ? 4 : 0;
        this.variables.sound_control = this.userInput.sound_control === "yes" ? 1 : 0;
    };
    Calculator.prototype.computeWellCost = function (step, mod) {
        if (mod === void 0) { mod = function (value) { return value; }; }
        this.costs[step].average = mod(+this.wellCosts[step].average);
        this.costs[step].upper = mod(+this.wellCosts[step].upper);
    };
    Calculator.prototype.computeWellCosts = function () {
        var _this = this;
        for (var i = 23; i <= 47; i++) {
            this.costs[i] = { average: 0, upper: 0 };
        }
        this.computeWellCost(23); // 23
        this.computeWellCost(24); // 24
        this.computeWellCost(25, function (v) { return (_this.variables.water_quality_zone_tests ? v : 0); }); // 25
        this.computeWellCost(26); // 26
        this.computeWellCost(27, function (v) { return v * 50.5; }); // 27
        this.computeWellCost(28, function (v) { return v * _this.userInput.total_depth; }); // 28
        this.computeWellCost(29); // 29
        this.computeWellCost(30, function (v) { return v * _this.variables.water_quality_zone_tests; }); // 30
        this.computeWellCost(31, function (v) { return v * _this.variables.water_quality_zone_tests * 18; }); // 31
        this.computeWellCost(32, function (v) { return v * _this.variables.water_quality_zone_tests; }); // 32
        this.computeWellCost(33, function (v) { return v * _this.userInput.total_depth; }); // 33
        this.computeWellCost(34); // 34
        this.computeWellCost(35, function (v) { return v * _this.variables.total_screen_length; }); // 35
        this.computeWellCost(36, function (v) { return v * _this.userInput.annular_seal_depth; }); // 36
        this.computeWellCost(37, function (v) { return v * 4 * (_this.variables.total_screen_length / 10); }); // 37
        this.computeWellCost(38); // 38
        this.computeWellCost(39, function (v) { return v * 60; }); // 39
        this.computeWellCost(40, function (v) { return v * 36; }); // 40
        this.computeWellCost(41); // 41
        this.computeWellCost(42); // 42
        this.computeWellCost(43); // 43
        var installedScreenCost = this.variables.total_screen_length * this.variables.screen_weight * this.variables.casing_screen_material_cost;
        this.costs[44].average = installedScreenCost * 1.35;
        this.costs[44].upper = installedScreenCost * 1.5;
        var installedCasingCost = this.variables.total_casing_length * this.variables.casing_weight * this.variables.casing_screen_material_cost;
        this.costs[45].average = installedCasingCost * 1.35;
        this.costs[45].upper = installedCasingCost * 1.5;
        var soundingTubeCost = this.variables.sounding_tube_length * this.variables.sounding_tube_unit_cost;
        this.costs[46] = { average: soundingTubeCost, upper: soundingTubeCost };
        var gravelFeedTubeCost = this.variables.gravel_feed_tube_length * this.variables.gravel_feed_tube_unit_cost;
        this.costs[47] = { average: gravelFeedTubeCost, upper: gravelFeedTubeCost };
    };
    Calculator.prototype.roundToNearestThousand = function (value) {
        return Math.round(value / 1000) * 1000;
    };
    Calculator.prototype.calculate = function () {
        this.computeVariables();
        this.computeWellCosts();
        this.total.upper = this.roundToNearestThousand(+Object.values(this.costs)
            .reduce(function (total, next) { return total + next.upper; }, 0)
            .toFixed());
        this.total.average = this.roundToNearestThousand(+Object.values(this.costs)
            .reduce(function (total, next) { return total + next.average; }, 0)
            .toFixed());
    };
    return Calculator;
}());
export { Calculator };
